import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SubmitComplianceSignage, fetchInitialState, updateFairhousingSignOption, updateLaborLawSignOption } from './complianceSignageSlice';
import { BACKEND_API_URL } from '../../config';
import QuestionareComponent from '../../components/questionareComponent';
import Loader from '../../components/loader';
import { StepHeading, StepShell } from '../../components/optionCard';
import FairHousingPoster from '../../img/FAIR_HOUSING_POSTER_ENG.pdf';
import { showRejectedError } from "../../admin/components/onboarding/apiHelper";
// import HDMAPoster from '../../img/HOME_MORTGAGE_DISCLOSURE_ACT_NOTICE.pdf';


const ComplianceSignage = () => {
    const complianceSignageState = useSelector(state => state.compliance_signage);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchInitialState())
    }, [dispatch])

    const handleFileChange = (e) => {
      let name;
      let uploadedFile;
      if (e.target.files && e.target.files.length > 0) {
        // Handle file selection via input
          name = e.target.name;
          uploadedFile = e.target.files[0];
      } else if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
          // Handle file drop
          name = e.currentTarget.dataset.name;
          uploadedFile = e.dataTransfer.files[0];
      }
      
      if (uploadedFile) {
        if (name === 'fairhousing') dispatch(
                              SubmitComplianceSignage({
                                   name,
                                   data: {
                                      ...complianceSignageState.data,
                                    'fairhousing_sign_image': uploadedFile,
                                    'fairhousing_sign_option':  complianceSignageState.data.fairhousing_sign_option
                                  }
                              })
                            ).unwrap().catch(showRejectedError())
        // else if (name === 'hdma') dispatch(SubmitComplianceSignage({ ...complianceSignageState.data,
        //                           'hdma_sign_image': uploadedFile, 
        //                           'hdma_sign_option':  complianceSignageState.data.hdma_sign_option
        //                         }))

        else if (name === 'labor_law') dispatch(SubmitComplianceSignage({
                                                                         name,
                                                                         data: {
                                                                          ...complianceSignageState.data,
                                                                          'labor_law_sign_image': uploadedFile,
                                                                          'labor_law_sign_option':  complianceSignageState.data.labor_law_sign_option
                                                                         }
                                                                        })).unwrap().catch(showRejectedError())
      }
      e.target.value = null;
    }

    const handleDelete = (e) => {
        e.preventDefault()
        const  name  = e.target.name || e.currentTarget.getAttribute('data-name');
        if (name === 'fairhousing') dispatch(SubmitComplianceSignage({
                                                        name,
                                                        data: { ...complianceSignageState.data,
                                                          'fairhousing_sign_image': 'delete',
                                                          'fairhousing_sign_option':  complianceSignageState.data.fairhousing_sign_option
                                                        }
                                                      })).unwrap().catch(showRejectedError())
        // else if (name === 'hdma') dispatch(SubmitComplianceSignage({ ...complianceSignageState.data,
        //                       'hdma_sign_image': 'delete', 
        //                       'hdma_sign_option':  complianceSignageState.data.hdma_sign_option
        //                     }))

        else if (name === 'labor_law') dispatch(SubmitComplianceSignage({
                                                        name,
                                                        data: { ...complianceSignageState.data,
                                                          'labor_law_sign_image': 'delete',
                                                          'labor_law_sign_option':  complianceSignageState.data.labor_law_sign_option
                                                        }
                                                  })).unwrap().catch(showRejectedError())
        }

    
    const handleDownload = (e) => {
      e.preventDefault()
      let image_name;
      const name = e.target.name || e.currentTarget.getAttribute('data-name');
      // console.log(name, e.currentTarget.getAttribute('data-name'));
      if (name === 'fairhousing') image_name =  complianceSignageState.data.fairhousing_sign_image;
      // else if (name === 'hdma') image_name =  complianceSignageState.data.hdma_sign_image;
      else if (name === 'labor_law') image_name =  complianceSignageState.data.labor_law_sign_image;      
        
      const url = `${BACKEND_API_URL}/api/files/download?path=${encodeURIComponent(image_name)}`
      fetch(url)
          .then(response => response.blob())
          .then(blob => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.style.display = 'none';
              a.href = url;
              // Specify a filename for the downloaded file
              a.download = image_name.split("/").pop();
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
          })
          .catch(err => console.error('Fetch error:', err));
    };

    return (
    <>
        { complianceSignageState.loading && <Loader /> }
        <StepShell>
            <StepHeading>
                Compliance Signage
            </StepHeading>
        </StepShell>
        {/* Fairhousing Poster */}
        <QuestionareComponent 
            title={"Do you have an Equal Housing Lender/ECOA poster/sign in your office?"}
            name={"fairhousing"}
            _option={complianceSignageState.data.fairhousing_sign_option}
            _image={complianceSignageState.data.fairhousing_sign_image}
            image_title={"Fairhousing Sign"}
            sign_download_link={FairHousingPoster}
            sign_download_name={"Fairhousing_Sign_Poster"}
            sign_download_title={'Click to download the Poster.'}
            handleYes={() => dispatch(updateFairhousingSignOption('Yes'))} 
            handleNo={() => dispatch(updateFairhousingSignOption('No'))}
            handleDownload={handleDownload}
            handleDelete={handleDelete}
            handleFileChange={handleFileChange}
            key={"fairhousing"}
        />

        {/* Home Mortgage Disclosure Act (HMDA) Poster */}
        {/* <QuestionareComponent 
            title={"Do you have a Home Mortgage Disclosure Act (HMDA) poster/sign in your office?"}
            name={"hdma"}
            _option={complianceSignageState.data.hdma_sign_option}
            _image={complianceSignageState.data.hdma_sign_image}
            image_title={"HDMA Sign"}
            sign_download_link={HDMAPoster}
            sign_download_name={"HOME_MORTGAGE_DISCLOSURE_ACT_NOTICE"}
            sign_download_title={'Click to download HDMA Sign.'}
            handleYes={() => dispatch(updateHDMASignOption('Yes'))} 
            handleNo={() => dispatch(updateHDMASignOption('No'))}
            handleDownload={handleDownload}
            handleDelete={handleDelete}
            handleFileChange={handleFileChange}
            key={"hdma"}
        /> */}

        {/* Labor Law Poster */}
        <QuestionareComponent 
            title={"Do you have all applicable, current Labor Law Poster(s)?"}
            name={"labor_law"}
            _option={complianceSignageState.data.labor_law_sign_option}
            _image={complianceSignageState.data.labor_law_sign_image}
            image_title={"Labor Law Sign"}
            sign_download_link={complianceSignageState.data.labor_law_sign_link}
            sign_download_name={''}
            sign_download_title={''}
            handleYes={() => dispatch(updateLaborLawSignOption('Yes'))} 
            handleNo={() => dispatch(updateLaborLawSignOption('No'))}
            handleDownload={handleDownload}
            handleDelete={handleDelete}
            handleFileChange={handleFileChange}
            key={"labor_law"}
        />
    </>
  )
}

export default ComplianceSignage;
